import React, { Component } from 'react';
import { getIcon } from '../../../Common/Common';
import Advanced_Settings from './Components/Advanced_Settings';
import { pushCommand, pushGroupCommand, isEmpty, addAnimation } from '../../../Common/Common';

import Power_On_Off from './Components/Power_On_Off';
import Off_Timer from './Components/Off_Timer';

export default class GeneralOperation extends Component {
	constructor(props) {
		super(props);

		this.group_types = [];
		// Changed on_off to default variable
		// Cannot use this.props.point_infoc
		let on_off = 'off';

		this.non_operationable_device_types = ["Status", "SensorStat", "Occupied"];

		for (let point_id of this.props.group_info.mp) {
			let point_info = window.app.state.point_list[point_id];
			if (!isEmpty(point_info)) {
				if (!this.group_types.includes(point_info.type)) {
					this.group_types.push(point_info.type);
				}

				// Tommy - 21/09/21
				// If device type is not operationable
				if (!this.non_operationable_device_types.includes(point_info.type)) {
					if (point_info.stat == 'on' && point_info.comm_stat == true) on_off = 'on';
				}

			}
		}

		this.state = {
			on_off: on_off,
		}
	}

	//Send command to the controller
	handleSendCommand = (command, val) => {
		// Check whether it is a point operation or group operation
		if (this.props.group_id != null) {
			pushGroupCommand(command, val, this.props.group_id);
		} else if (this.props.point_id != null) {
			this.target_id = this.props.point_id;
			pushCommand(command, val, this.props.point_id);
		}
	}

	//Power On/Off
	handleOnOff = () => {
		let val = 'off';
		let elem = document.getElementById('icon_container');

		if (this.state.on_off == 'off') {
			val = 'on';
			addAnimation(elem, 'fadeInLong', () => { }, 2000)
			this.setState({ on_off: 'on' });
		} else {
			addAnimation(elem, 'fadeOutLongFast', () => {
				this.setState({ on_off: 'off' });
			}, 200)
		}
		let command = 'stat';
		this.handleSendCommand(command, val);
	}

	//Off timer
	handleToggleOffTimer = (val) => {
		let command = 'off_timer';
		this.handleSendCommand(command, val);
	}

	//Off timer duration
	handleChangeOffDuration = (val) => {
		let command = 'off_duration';
		this.handleSendCommand(command, val);
	}

	render() {
		let icon = getIcon(this.props.group_info.icon);
		let icon_width = 50;
		let power_icon_width = 150
		let background_gradient = 'radial-gradient(#8dff95 5%, #daffda 50%, #fffcfc 70%)';
		let icon_container_style = {
			width: icon_width + 30,
			height: icon_width + 30,
			position: 'absolute',
			top: -(power_icon_width + 10),
			left: 20,
			backgroundImage: background_gradient,
			display: this.state.on_off == 'on' ? 'block' : 'none',
		}

		let op_button_cell_style = {
			width: this.props.width - 80,
			marginTop: 20,
			paddingBottom: 10,
			paddingTop: 10,
			marginLeft: 'auto',
			marginRight: 'auto',
			backgroundColor: 'white',
			borderRadius: 20,
			boxShadow: '0 0 3px rgba(0, 0, 0, 0.2)',
			fontSize: 11,
		}

		let show_off_timer = false;

		if(this.props.receiver.active_controller.user_class == 'Admin') {
			if (this.group_types.includes('LevelSw') || this.group_types.includes('Ac')
				|| this.group_types.includes('Switch') || this.group_types.includes('Dehumi')) {
				show_off_timer = true;
			}
		}

		return (
			<div id='general_operation' >
				<div style={{ cursor: 'pointer', }} onClick={this.handleOnOff}>
					<div style={{ verticalAlign: 'top', marginTop: 20 }}>
						<Power_On_Off
							style={{}}
							img_width={power_icon_width}
							receiver={this.props.receiver}
							point_info={this.props.point_info}
							on_off={this.state.on_off} />
					</div>
					<div style={{ position: 'relative' }}>
						<div id='icon_container' style={icon_container_style}></div>
						<img id={'device_icon'} src={icon} alt='icon' style={{ width: icon_width, opacity: 0.6, position: 'absolute', top: -(power_icon_width - 5), left: 35, }} />
					</div>
				</div>

				{show_off_timer ? <Off_Timer
					style={op_button_cell_style}
					receiver={this.props.receiver}
					point_info={this.props.point_info}
					handleToggleOffTimer={this.handleToggleOffTimer}
				/> : null}

				<div style={{ height: 20 }}></div>

				{show_off_timer ? <Advanced_Settings
					point_id={this.props.point_id}
					point_info={this.props.point_info}
					receiver={this.props.receiver}
					width={this.props.width}
					height={this.props.height}
					group_info={this.props.group_info}
					group_id={this.props.group_id}
					type={'General'}
					colours={this.props.colours}
				/>
					: null}

			</div>
		)
	}
}